// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"src_app_dashboard_dashboard_module_ts":"54488e7c3f28bf91","src_app_session_session_module_ts":"ac196a4c3bbd09aa","node_modules_pnpm_socket_io-client_4_8_3_node_modules_socket_io-client_build_esm_index_js":"2d3154538a1e8459"}[chunkId] + ".js";
};